import React, {useState} from 'react';
import cl from "../BaseSimplePage/BaseSimplePage.module.css";
import AlertSnackbar from "../../components/AlertSnackbar/AlertSnackbar";
import LoadingOverlay from "../../components/LoadingOverlay/LoadingOverlay";
import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";
import WeightCoefficientsEditor from "./WeightCoefficientsEditor";
import ServerManager from "../../API/ServerManager";

const WeightCoefficientsPage = ({isAddSubMode}) => {

    const [editorKey, setEditorKey] = useState(0);

    const [loadingOverlayData, setLoadingOverlayData] = useState(null); // { title }
    const [snackbarData, setSnackbarData] = useState(null); // { severity, title, message }
    const [confirmDialogData, setConfirmDialogData] = useState(null); // { message, confirmLabel, cancelLabel, onAnswer }

    async function handleSave(data) {
        setLoadingOverlayData({title: "Сохранение"})

        try {
            await ServerManager.saveWeightCoefficients({coefficients: data});
        } catch (error) {
            setLoadingOverlayData(null);
            setSnackbarData({severity: "error", title: "Ошибка при сохранении!", message: error});
            return;
        }

        // успешно сохранено

        setLoadingOverlayData(null);
        setSnackbarData({severity: "success", message: "Данные сохранены"});
        setEditorKey(editorKey + 1);
    };

    const handleErrorSnackbarClose = (event, reason) => {
        setSnackbarData(null);
    };

    function renderItemEditor(key, props) {
        return <WeightCoefficientsEditor {...props} key={key}/>
    }

    return (
        <div className={cl.main0}>
            <div className={cl.mainRow}>
                {<div className={cl.editorArea}>
                    {renderItemEditor(editorKey, {
                        onSave: handleSave,
                        setSnackbarData: setSnackbarData,
                    })}
                </div>}
            </div>
            {snackbarData && <AlertSnackbar
                open={true}
                severity={snackbarData.severity}
                title={snackbarData.title}
                message={<div style={{whiteSpace:"pre-line"}}>{snackbarData.message}</div>}
                onClose={handleErrorSnackbarClose}
            />}
            {loadingOverlayData && <LoadingOverlay
                open={true}
                title={loadingOverlayData.title}
            />}
            {confirmDialogData && <ConfirmDialog
                open={true}
                message={confirmDialogData.message}
                confirmLabel={confirmDialogData.confirmLabel}
                cancelLabel={confirmDialogData.cancelLabel}
                onAnswer={confirmDialogData.onAnswer}
            />}
        </div>
    );
};

export default WeightCoefficientsPage;